import { Children } from "react";
import { augmentElement, createSizeAdapter } from "../../shared";
import { useResponsiveValue } from "../../styling";

/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */
export const embeddedIconSize = createSizeAdapter({
  "2xs": "2xs",
  "xs": "2xs",
  "sm": "xs",
  "md": "sm",
  "lg": "md",
  "xl": "lg",
  "inherit": "inherit"
});
/* eslint-enable sort-keys, sort-keys-fix/sort-keys-fix */

export function EmbeddedIcon({
  children,
  size,
  ...rest
}) {
  const sizeValue = useResponsiveValue(size);
  const icon = Children.only(children);
  return augmentElement(icon, {
    size: embeddedIconSize(sizeValue),
    ...rest
  });
}